module.exports = __webpack_public_path__ + "img/Symbol_2.48c207b7.png";